import type React from "react";

type IconProps = React.ComponentProps<"svg">;

function Icon({ children, ...props }: IconProps) {
	return (
		<svg
			data-slot="icon"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			{...props}
		>
			{children}
		</svg>
	);
}

export function CheckIcon(props: IconProps) {
	return (
		<Icon strokeWidth={2.4} {...props}>
			<path d="M5 12.5l4.5 4.5L19 7.5" />
		</Icon>
	);
}

export function ArrowIcon(props: IconProps) {
	return (
		<Icon strokeWidth={2.2} {...props}>
			<path d="M5 12h14M13 6l6 6-6 6" />
		</Icon>
	);
}

export function CloudIcon(props: IconProps) {
	return (
		<Icon strokeWidth={1.8} {...props}>
			<path d="M8 5.5a3.5 3.5 0 0 1 5.9 1.4M4.5 9.5l-1-.5M6 4l-.4-1M11 2.5v-.9M7.5 19h9a3.5 3.5 0 0 0 .4-7 5 5 0 0 0-9.6 1.2A3 3 0 0 0 7.5 19z" />
		</Icon>
	);
}
